export const translations = {
  ru: {
    // Header
    nav: {
      os: 'VLAGEN OS',
      industries: 'Отрасли',
      cases: 'Кейсы',
      methodology: 'Методология',
      partners: 'Партнёры',
      company: 'Компания',
      contact: 'Контакты',
      cta: 'Установить контроль',
      backHome: 'На главную'
    },
    // Footer
    footer: {
      brand: 'Операционная инфраструктура для бизнеса со сложными процессами.',
      product: 'Продукт',
      company: 'Компания',
      contact: 'Контакты',
      methodology: 'Архитектура',
      industries: 'Решения',
      cases: 'Кейсы',
      about: 'О компании',
      partners: 'Партнёрам',
      blog: 'Блог',
      address: 'Дубай, ОАЭ',
      rights: 'Все права защищены.',
      privacy: 'Политика конфиденциальности',
      cookies: 'Уведомление о cookies',
      legal: 'Юридическая информация',
      contactTitle: 'Контакты'
    },
    // Legal
    legal: {
      privacyTitle: 'Политика обработки персональных данных',
      privacyLastUpdated: 'Последнее обновление',
      consentCheckbox: 'Я согласен на обработку персональных данных',
      consentLink: 'в соответствии с',
      privacyPolicy: 'Политикой конфиденциальности',
      cookieNotice: 'Этот сайт использует файлы cookie для корректной работы и улучшения пользовательского опыта. Продолжая пользоваться сайтом, вы соглашаетесь с их использованием.',
      cookieAccept: 'Понятно',
      sections: {
        intro: {
          title: 'Введение',
          content: 'Настоящая Политика обработки персональных данных описывает, как VLAGEN GROUP («Компания», «мы», «нас») собирает, использует и защищает персональные данные, которые вы предоставляете при использовании нашего веб-сайта vlagengroup.com.'
        },
        dataCollected: {
          title: 'Какие данные мы собираем',
          content: 'При заполнении контактной формы на нашем сайте мы собираем следующие персональные данные:',
          items: [
            'Имя и фамилия',
            'Адрес электронной почты',
            'Номер телефона',
            'Название компании',
            'Сфера деятельности',
            'Текст сообщения'
          ]
        },
        purpose: {
          title: 'Цели обработки данных',
          content: 'Мы используем ваши персональные данные исключительно для следующих целей:',
          items: [
            'Ответ на ваши запросы и обращения',
            'Связь с вами по вопросам сотрудничества',
            'Предоставление информации о наших услугах',
            'Улучшение качества обслуживания'
          ]
        },
        storage: {
          title: 'Хранение и защита данных',
          content: 'Мы принимаем необходимые технические и организационные меры для защиты ваших персональных данных от несанкционированного доступа, изменения, раскрытия или уничтожения. Данные хранятся на защищённых серверах с ограниченным доступом.'
        },
        sharing: {
          title: 'Передача данных третьим лицам',
          content: 'Мы не передаём ваши персональные данные третьим лицам без вашего согласия, за исключением случаев, предусмотренных законодательством.'
        },
        rights: {
          title: 'Ваши права',
          content: 'Вы имеете право:',
          items: [
            'Запросить информацию о ваших персональных данных, которые мы обрабатываем',
            'Потребовать исправления неточных данных',
            'Потребовать удаления ваших персональных данных',
            'Отозвать согласие на обработку данных'
          ]
        },
        contact: {
          title: 'Контакты',
          content: 'По всем вопросам, связанным с обработкой персональных данных, вы можете обратиться к нам по адресу электронной почты:'
        }
      }
    },
    // Hero
    hero: {
      tagline: 'Цифровой слой управления',
      titleLine1: 'Контролируйте операционную',
      titleLine2: 'деятельность',
      titleAccent: 'поверх существующих систем.',
      subtitle: 'Единая операционная платформа, которая объединяет данные, процессы и системы в одном интерфейсе.',
      description: 'Без перестройки бизнеса.',
      ctaPrimary: 'Установить контроль',
      ctaSecondary: 'Изучить VLAGEN OS'
    },
    // Foundation
    foundation: {
      label: 'ФУНДАМЕНТ',
      title: 'Базовый слой',
      description: 'Фундамент каждого внедрения VLAGEN. Объединение данных, управление процессами и отчётность в единой командной поверхности.',
      dataUnification: 'Объединение данных',
      dataUnificationDesc: 'Консолидация данных из всех систем в единый источник информации.',
      processGovernance: 'Управление процессами',
      processGovernanceDesc: 'Определение, применение и аудит операционных процессов с детальным контролем.',
      executiveReporting: 'Операционная аналитика',
      executiveReportingDesc: 'Панели мониторинга в реальном времени и аналитика для принятия управленческих решений.'
    },
    // Modules
    modules: {
      title: 'Отраслевые модули',
      description: 'Специализированные расширения для конкретных операционных сред.',
      warehouse: 'Блок склада',
      warehouseDesc: 'Управление запасами, контроль таможенных товаров, автоматизация выпуска.',
      customs: 'Таможенный модуль',
      customsDesc: 'Контроль деклараций, оркестрация соответствия, прозрачность растаможки.',
      logistics: 'Блок логистики',
      logisticsDesc: 'Координация отгрузок, отслеживание автопарка, управление затратами.',
      trading: 'Торговый модуль',
      tradingDesc: 'Надзор за партнёрами, управление ценообразованием, аудит транзакций.',
      compliance: 'Блок соответствия',
      complianceDesc: 'Регуляторная отчётность, автоматизация аудита, мониторинг рисков.',
      analytics: 'Блок аналитики',
      analyticsDesc: 'Управленческие панели, отслеживание KPI, анализ эффективности.'
    },
    // Problems
    problems: {
      label: 'Вызов',
      title: 'Операционные проблемы, которые мы устраняем',
      description: 'VLAGEN превращает разрозненные операции в структурированную, контролируемую среду.',
      problem1: 'Разрозненные ERP, CRM, складские и финансовые системы',
      problem2: 'Отсутствие видимости в реальном времени между командами',
      problem3: 'Регуляторные риски и риски соответствия',
      problem4: 'Утечки запасов и неэффективность капитала',
      problem5: 'Слабое управление операционными решениями'
    },
    // Security
    security: {
      label: 'Безопасность и доверие',
      title: 'Операционная безопасность корпоративного уровня',
      subtitle: 'Ваши данные остаются в вашей инфраструктуре.',
      description: 'VLAGEN работает как слой контроля внутри вашей экосистемы — не как посредник данных. Операционный контроль без ущерба суверенитету данных.',
      highlight: 'Операционный контроль без ущерба суверенитету данных.',
      notDoTitle: 'Принципы работы с данными',
      guaranteeTitle: 'Мы гарантируем',
      feature1: 'Без перепродажи данных',
      feature2: 'Без внешней эксплуатации',
      feature3: 'Без скрытого доступа третьих лиц',
      feature4: 'Ролевые разрешения',
      feature5: 'Полное журналирование аудита',
      feature6: 'Шифрование на уровне инфраструктуры'
    },
    // Architecture
    architecture: {
      label: 'Архитектура системы',
      title: 'Центральный слой управления',
      description: 'VLAGEN интегрируется над вашими ERP, CRM, WMS, финансовыми и торговыми системами — консолидируя операционные сигналы в единую командную поверхность.',
      note: 'Мы не заменяем ваши системы. Мы их согласовываем.',
      diagramTitle: 'Архитектура операционного управления',
      layer1: 'Командная поверхность',
      layer2: 'Слой контроля VLAGEN',
      layer3: 'ERP / CRM / WMS / Финансы / Торговые системы',
      dataFlow: 'Поток данных',
      controlLayer: 'Слой контроля'
    },
    // Industries
    industries: {
      label: 'ФОКУС НА ОТРАСЛЯХ',
      title: 'Инфраструктура управляемости для сложного бизнеса',
      description: 'Единая архитектура контроля для компаний с высокой операционной и регуляторной нагрузкой.',
      intro: 'VLAGEN объединяет склад, импорт, дистрибуцию, логистику и финансы в единую систему контроля, прозрачности и принятия решений.',
      warehouse: 'Складская инфраструктура и управление запасами',
      warehouseDesc: 'Контроль остатков в реальном времени. Бондовые и свободные режимы хранения. Резервирование, выпуск и перемещение товаров. Управление оборотным капиталом. Прозрачность движения активов.',
      customs: 'Импорт и регуляторное администрирование',
      customsDesc: 'Таможенные процедуры и сопровождение поставок. Контроль соответствия требованиям. Документооборот и трассируемость операций. Снижение регуляторных и операционных рисков.',
      distribution: 'Распределение и торговая архитектура',
      distributionDesc: 'Ценообразование и управление маржинальностью. Контроль сделок и финансовой дисциплины. Партнёрские лимиты и коммерческая политика. Управление торговыми потоками и оборотом.',
      logistics: 'Логистика и координация потоков',
      logisticsDesc: 'Маршрутизация и контроль отгрузок. Управление автопарком и затратами. Отслеживание движения товаров. Синхронизация складских и транспортных процессов.',
      importExport: 'B2B-экосистема и управление партнёрами',
      importExportDesc: 'Единая модель данных контрагентов. Контроль договорных обязательств. Финансовая дисциплина и лимиты. Аудит операций и управление рисками.',
      b2b: 'Операционная аналитика и AI-поддержка решений',
      b2bDesc: 'Сквозная управленческая отчётность. Контроль KPI и маржинальной эффективности. Прогнозирование спроса и оборота. Выявление аномалий и точек потерь. AI-рекомендации для стратегических решений.'
    },
    // Stats
    stats: {
      implementations: 'Внедрений',
      countries: 'Стран',
      retention: 'Удержание клиентов',
      support: 'Поддержка'
    },
    // Clients
    clients: {
      label: 'НАМ ДОВЕРЯЮТ',
      title: 'Компании, которые выбрали VLAGEN',
      vterminal: 'Сократили время обработки на 40%',
      tdnebo: 'Объединили 5 систем в одну панель',
      xport: 'Полный контроль над логистикой'
    },
    
    // CTA
    cta: {
      title: 'Установите структурный контроль.',
      description: 'Запланируйте стратегическую сессию развёртывания с нашим инженерным руководством.',
      primary: 'Установить контроль',
      secondary: 'Изучить VLAGEN OS'
    },
    // Testimonials
    testimonials: {
      label: 'Успех клиентов',
      title: 'Нам доверяют лидеры операций',
      quote1: 'VLAGEN дал нам видимость, которой у нас никогда не было. Теперь мы можем видеть все наши складские операции в реальном времени.',
      role1: 'Директор по операциям',
      company1: 'Логистика и складирование',
      quote2: 'Блок таможенного соответствия сократил время растаможки на 40%. ROI был очевиден уже в первом квартале.',
      role2: 'Менеджер по торговому соответствию',
      company2: 'Импорт/Экспорт',
      quote3: 'Наконец, система, которая работает с нашим существующим ERP, а не заменяет его. Подключение было бесшовной.',
      role3: 'ИТ-директор',
      company3: 'Распределение'
    },
    // FAQ
    faq: {
      label: 'Часто задаваемые вопросы',
      title: 'Вопросы о VLAGEN',
      q1: 'Что такое операционная инфраструктура?',
      a1: 'Операционная инфраструктура — это слой контроля, который находится над вашими существующими бизнес-системами (ERP, CRM, WMS и т.д.) для объединения данных, обеспечения управления и предоставления исполнительной видимости по всем операциям.',
      q2: 'Заменяет ли VLAGEN наши существующие системы?',
      a2: 'Нет. VLAGEN интегрируется над вашими существующими системами без замены или сбоев. Мы подключаемся к вашим ERP, CRM, WMS, финансовым и торговым системам для консолидации операционных сигналов в единую поверхность управления.',
      q3: 'Какие отрасли обслуживает VLAGEN?',
      a3: 'VLAGEN обслуживает высокосложные операционные среды, включая складские и активовые операции, таможенное и торговое управление, дистрибьюторские сети, логистику и автопарк, импортно-экспортные операции и B2B торговые платформы.',
      q4: 'Безопасны ли мои данные с VLAGEN?',
      a4: 'Ваши данные остаются в вашей инфраструктуре. VLAGEN работает как слой контроля внутри вашей экосистемы — не как посредник данных.',
      q5: 'Сколько времени занимает развёртывание VLAGEN?',
      a5: 'Развёртывание следует нашей 5-фазной структуре. Сроки варьируются в зависимости от сложности, обычно 4-12 недель для начального развёртывания.'
    },
    // OS Page
    os: {
      label: 'LIVE DEMO',
      title: 'VLAGEN OS',
      subtitle: 'Операционная панель в реальном времени',
      description: 'Видимость в реальном времени вашей операционной экосистемы. Эта демонстрация показывает, как VLAGEN консолидирует сигналы из складских, таможенных, логистических и торговых систем.',
      requestDemo: 'Запросить полную демо',
      lastUpdate: 'Последнее обновление:',
      secondsAgo: 'секунд назад',
      activeOrders: 'Активные заказы',
      inTransit: 'В пути',
      pendingClearance: 'Ожидают растаможки',
      completedToday: 'Завершено сегодня',
      warehouseStatus: 'Статус склада',
      operational: 'Работает',
      totalUnits: 'Всего единиц на складе',
      bondedWarehouse: 'Таможенный склад',
      customsProcessing: 'Таможенное оформление',
      processing: 'Обработка',
      declarationsToday: 'Деклараций сегодня',
      approved: 'Одобрено',
      pending: 'На проверке',
      logisticsOverview: 'Обзор логистики',
      onTimeDelivery: 'Доставка вовремя',
      fleetUtilization: 'Загрузка автопарка'
    },
    // Blog Page
    blog: {
      label: 'БЛОГ',
      title: 'Инсайты и статьи',
      subtitle: 'Экспертные материалы об операционной эффективности и управлении бизнесом',
      ctaTitle: 'Хотите узнать больше?',
      ctaDescription: 'Запланируйте бесплатную консультацию с нашими экспертами',
      ctaButton: 'Связаться',
      allArticles: 'Все статьи',
      readyToOptimize: 'Готовы оптимизировать операции?',
      scheduleConsultation: 'Запланируйте бесплатную консультацию с нашими экспертами',
      getConsultation: 'Получить консультацию',
      readAlso: 'Читайте также'
    },
    // Contact Page
    contact: {
      label: 'КОНТАКТЫ',
      title: 'Начнём разговор',
      subtitle: 'Оставьте заявку — мы свяжемся в течение 24 часов',
      description: 'Расскажите о вашем бизнесе, и мы подготовим предварительную оценку возможностей внедрения VLAGEN.',
      
      formTitle: 'Заявка на консультацию',
      fullName: 'Имя',
      workEmail: 'Email',
      company: 'Компания',
      phone: 'Телефон',
      industry: 'Сфера деятельности',
      selectIndustry: 'Выберите сферу',
      message: 'Расскажите о вашей задаче',
      messagePlaceholder: 'Какие операционные процессы требуют контроля? Какие системы используете?',
      submit: 'Отправить заявку',
      
      contactInfo: 'Контактная информация',
      address: 'Дубай, ОАЭ',
      workingHours: 'Вс — Чт: 9:00 — 18:00 (GST)',
      phoneLabel: 'Телефон',
      emailLabel: 'Email',
      officeLabel: 'Офис',
      hoursLabel: 'Часы работы',
      
      responseTitle: 'Что будет дальше?',
      responseSteps: [
        'Изучим вашу заявку',
        'Свяжемся для уточнения деталей',
        'Предложим формат сотрудничества'
      ],
      
      successTitle: 'Спасибо!',
      successSubtitle: 'Ваша заявка получена.',
      successMessage: 'Наша команда свяжется с вами в ближайшее время для обсуждения вашего проекта.',
      backHome: 'Вернуться на главную',
      sending: 'Отправка...'
    },
    // Methodology Page
    methodology: {
      label: 'АРХИТЕКТУРА',
      title: 'Как мы внедряем VLAGEN',
      subtitle: 'Структурированный подход к построению операционного контроля без разрушения существующих процессов.',
      
      introTitle: 'Почему это работает',
      introDesc1: 'Мы не продаём коробочный продукт.',
      introDesc2: 'Каждое внедрение начинается с понимания вашей операционной реальности.',
      
      phase1: 'Диагностика',
      phase1Sub: 'Понимание операций',
      phase1Time: '1-2 недели',
      phase1Desc: 'Глубокий аудит существующих систем, процессов и точек потерь контроля. Формируем карту операционного ландшафта.',
      phase1Items: ['Аудит систем (ERP, WMS, CRM)', 'Карта процессов и потоков', 'Выявление узких мест', 'Определение приоритетов'],
      
      phase2: 'Архитектура',
      phase2Sub: 'Проектирование решения',
      phase2Time: '2-3 недели',
      phase2Desc: 'Проектируем слой контроля под вашу операционную модель. Определяем точки интеграции и структуру управления.',
      phase2Items: ['Архитектура слоя контроля', 'Модель данных и интеграций', 'Структура ролей и доступов', 'План поэтапного внедрения'],
      
      phase3: 'Подключение',
      phase3Sub: 'Подключение систем',
      phase3Time: '3-6 недель',
      phase3Desc: 'Разворачиваем VLAGEN поверх существующих систем. Настраиваем потоки данных, дашборды и автоматизации.',
      phase3Items: ['Подключение к ERP/WMS/CRM', 'Настройка потоков данных', 'Настройка панелей управления', 'Автоматизация процессов'],
      
      phase4: 'Проверка',
      phase4Sub: 'Проверка качества',
      phase4Time: '1-2 недели',
      phase4Desc: 'Тестирование всех интеграций и сценариев. Верифицируем корректность данных и работу автоматизаций.',
      phase4Items: ['Тестирование подключений', 'Проверка данных', 'Тестирование с ключевыми пользователями', 'Аудит безопасности'],
      
      phase5: 'Запуск',
      phase5Sub: 'Выход в эксплуатацию',
      phase5Time: 'Постоянно',
      phase5Desc: 'Плавный переход в рабочий режим. Обучение команды, мониторинг и постоянная поддержка.',
      phase5Items: ['Обучение пользователей', 'Запуск в эксплуатацию', 'Отслеживание и оповещение', 'Поддержка и развитие'],
      
      phasesLabel: 'ВНЕДРЕНИЕ',
      phasesTitle: 'Фазы внедрения',
      
      timelineTitle: 'Типичные сроки',
      timelineDesc: 'От старта до запуска: 8-14 недель в зависимости от масштаба и сложности интеграций.',
      totalTime: '8-14 недель',
      timelineStart: 'Старт',
      timelineLaunch: 'Запуск',
      
      ctaTitle: 'Начнём с диагностики',
      ctaDesc: 'Бесплатная консультация для оценки вашей операционной среды.',
      ctaButton: 'Запланировать звонок'
    },
    // Industries Page
    industriesPage: {
      label: 'РЕШЕНИЯ',
      title: 'Операционный контроль по секторам',
      subtitle: 'VLAGEN адаптируется под специфику вашей отрасли, сохраняя единую архитектуру управления.',
      
      warehouse: {
        title: 'Складская инфраструктура',
        desc: 'Полный контроль над запасами, режимами хранения и движением товаров.',
        features: ['Учёт остатков в реальном времени', 'Бондовые и свободные зоны', 'Резервирование и выпуск', 'Контроль оборотного капитала', 'Прозрачность движения активов']
      },
      customs: {
        title: 'Импорт и таможня',
        desc: 'Администрирование таможенных процедур и регуляторного соответствия.',
        features: ['Сопровождение поставок', 'Контроль соответствия', 'Документооборот', 'Трассируемость операций', 'Снижение рисков']
      },
      logistics: {
        title: 'Логистика и транспорт',
        desc: 'Координация потоков, управление автопарком и оптимизация затрат.',
        features: ['Маршрутизация отгрузок', 'Управление автопарком', 'Отслеживание движения', 'Контроль затрат', 'Синхронизация процессов']
      },
      distribution: {
        title: 'Распределение и торговля',
        desc: 'Управление ценообразованием, маржинальностью и торговыми потоками.',
        features: ['Ценовая политика', 'Контроль маржи', 'Финансовая дисциплина', 'Партнёрские лимиты', 'Управление оборотом']
      },
      trading: {
        title: 'B2B-экосистема',
        desc: 'Единая модель управления контрагентами и партнёрскими отношениями.',
        features: ['Данные контрагентов', 'Договорные обязательства', 'Лимиты и дисциплина', 'Аудит операций', 'Управление рисками']
      },
      importExport: {
        title: 'Аналитика и AI',
        desc: 'Сквозная отчётность, прогнозирование и AI-поддержка решений.',
        features: ['Управленческая отчётность', 'KPI и эффективность', 'Прогнозирование спроса', 'Выявление аномалий', 'AI-рекомендации']
      }
    },
    // Partners Page
    partnersPage: {
      label: 'ПАРТНЁРАМ',
      title: 'Партнёрская программа VLAGEN',
      subtitle: 'Создаём экосистему для масштабирования операционного контроля',
      intro: 'VLAGEN открыт для сотрудничества с компаниями, разделяющими нашу миссию — структурное управление сложными операциями.',
      
      whyTitle: 'Почему партнёрство с VLAGEN',
      whyItems: [
        'Доступ к растущему рынку операционной инфраструктуры',
        'Совместные проекты с крупными клиентами',
        'Техническая поддержка и обучение',
        'Маркетинговая и sales-поддержка'
      ],
      
      typesTitle: 'Типы партнёрства',
      
      integrationTitle: 'Интеграционные партнёры',
      integrationDesc: 'Разработчики ERP, WMS, CRM и финансовых систем. Совместная интеграция для бесшовного обмена данными.',
      integrationItems: ['API-интеграции', 'Коннекторы данных', 'Совместные решения'],
      
      consultingTitle: 'Консалтинговые партнёры',
      consultingDesc: 'Консультанты по цифровой трансформации и операционной эффективности. Совместное внедрение у клиентов.',
      consultingItems: ['Аудит операций', 'Внедрение VLAGEN', 'Обучение команд'],
      
      technologyTitle: 'Технологические партнёры',
      technologyDesc: 'Провайдеры облачной инфраструктуры, безопасности и аналитики. Совместное развитие платформы.',
      technologyItems: ['Облачная инфраструктура', 'Кибербезопасность', 'AI/ML решения'],
      
      processTitle: 'Процесс партнёрства',
      processSteps: [
        { num: '01', title: 'Заявка', desc: 'Заполните форму и расскажите о вашей компании' },
        { num: '02', title: 'Оценка', desc: 'Мы изучим синергию и потенциал сотрудничества' },
        { num: '03', title: 'Соглашение', desc: 'Определим условия и модель партнёрства' },
        { num: '04', title: 'Онбординг', desc: 'Техническое обучение и доступ к ресурсам' }
      ],
      
      ctaTitle: 'Готовы к сотрудничеству?',
      ctaDesc: 'Оставьте заявку и мы свяжемся с вами для обсуждения партнёрства.',
      ctaButton: 'Стать партнёром'
    },
    // Company Page
    companyPage: {
      label: 'О КОМПАНИИ',
      title: 'VLAGEN',
      subtitle: 'Операционная инфраструктура для бизнеса, где контроль — это конкурентное преимущество',
      
      missionTitle: 'Миссия',
      missionDesc: 'Мы создаём инфраструктуру управляемости для компаний со сложными операциями. Не заменяем существующие системы — объединяем их в единую архитектуру контроля.',
      
      visionTitle: 'Видение',
      visionDesc: 'Мир, где операционная сложность не тормозит рост бизнеса, а становится управляемым активом через единый слой контроля и прозрачности.',
      
      principlesTitle: 'Принципы',
      principles: [
        { title: 'Прозрачность', desc: 'Полная видимость операций на всех уровнях' },
        { title: 'Контроль', desc: 'Структурное управление без микроменеджмента' },
        { title: 'Подключение', desc: 'Работаем поверх, не заменяем' },
        { title: 'Безопасность', desc: 'Данные остаются в вашей инфраструктуре' }
      ],
      
      focusTitle: 'Фокус',
      focusDesc: 'Мы работаем с компаниями, где операционный контроль критичен:',
      focusItems: [
        'Склад и управление запасами',
        'Импорт и таможенное администрирование', 
        'Распределение и торговые операции',
        'Логистика и координация потоков',
        'B2B-экосистемы и партнёрские сети',
        'Финансовый контроль'
      ],
      
      approachTitle: 'Подход',
      approachDesc: 'VLAGEN — не SaaS-продукт с фиксированным функционалом. Это архитектура, которая адаптируется под вашу операционную модель.',
      approachItems: [
        { title: 'Диагностика', desc: 'Понимаем вашу операционную реальность' },
        { title: 'Архитектура', desc: 'Проектируем слой контроля под ваши процессы' },
        { title: 'Подключение', desc: 'Подключаем к существующим системам' },
        { title: 'Масштабирование', desc: 'Растём вместе с вашим бизнесом' }
      ],
      
      locationTitle: 'Присутствие',
      locationDesc: 'Штаб-квартира в Дубае, ОАЭ. Работаем с клиентами в регионе MENA, СНГ и глобально.',
      
      ctaTitle: 'Готовы к разговору?',
      ctaButton: 'Связаться с нами'
    }
  },
  en: {
    // Header
    nav: {
      os: 'VLAGEN OS',
      industries: 'Industries',
      cases: 'Cases',
      methodology: 'Methodology',
      partners: 'Partners',
      company: 'Company',
      contact: 'Contact',
      cta: 'Get Control',
      backHome: 'Back Home'
    },
    // Footer
    footer: {
      brand: 'Operational infrastructure for complex business processes.',
      product: 'Product',
      company: 'Company',
      contact: 'Contact',
      methodology: 'Architecture',
      industries: 'Solutions',
      cases: 'Case Studies',
      about: 'About',
      partners: 'Partners',
      blog: 'Blog',
      address: 'Dubai, UAE',
      rights: 'All rights reserved.',
      privacy: 'Privacy Policy',
      cookies: 'Cookie Notice',
      legal: 'Legal',
      contactTitle: 'Contact'
    },
    // Legal
    legal: {
      privacyTitle: 'Privacy Policy',
      privacyLastUpdated: 'Last updated',
      consentCheckbox: 'I agree to the processing of my personal data',
      consentLink: 'in accordance with the',
      privacyPolicy: 'Privacy Policy',
      cookieNotice: 'This website uses cookies to ensure proper functionality and improve user experience. By continuing to use the site, you agree to the use of cookies.',
      cookieAccept: 'OK',
      sections: {
        intro: {
          title: 'Introduction',
          content: 'This Privacy Policy describes how VLAGEN GROUP ("Company", "we", "us") collects, uses, and protects the personal data you provide when using our website vlagengroup.com.'
        },
        dataCollected: {
          title: 'What Data We Collect',
          content: 'When you fill out the contact form on our website, we collect the following personal data:',
          items: [
            'Full name',
            'Email address',
            'Phone number',
            'Company name',
            'Industry',
            'Message text'
          ]
        },
        purpose: {
          title: 'Purpose of Data Processing',
          content: 'We use your personal data exclusively for the following purposes:',
          items: [
            'Responding to your inquiries and requests',
            'Communicating with you regarding cooperation',
            'Providing information about our services',
            'Improving service quality'
          ]
        },
        storage: {
          title: 'Data Storage and Protection',
          content: 'We take necessary technical and organizational measures to protect your personal data from unauthorized access, alteration, disclosure, or destruction. Data is stored on secure servers with restricted access.'
        },
        sharing: {
          title: 'Sharing Data with Third Parties',
          content: 'We do not share your personal data with third parties without your consent, except as required by law.'
        },
        rights: {
          title: 'Your Rights',
          content: 'You have the right to:',
          items: [
            'Request information about your personal data that we process',
            'Request correction of inaccurate data',
            'Request deletion of your personal data',
            'Withdraw consent to data processing'
          ]
        },
        contact: {
          title: 'Contact',
          content: 'For all questions related to personal data processing, you can contact us at:'
        }
      }
    },
    // Hero
    hero: {
      tagline: 'Digital control layer',
      titleLine1: 'Control your operations',
      titleLine2: '',
      titleAccent: 'on top of existing systems.',
      subtitle: 'A unified operational platform that brings together data, processes, and systems in one interface.',
      description: 'Without rebuilding your business.',
      ctaPrimary: 'Establish Control',
      ctaSecondary: 'Explore VLAGEN OS'
    },
    // Foundation
    foundation: {
      label: 'FOUNDATION',
      title: 'Base Layer',
      description: 'The foundation of every VLAGEN implementation. Data unification, process management, and reporting in a single command surface.',
      dataUnification: 'Data Unification',
      dataUnificationDesc: 'Consolidate data from all systems into a single source of information.',
      processGovernance: 'Process Governance',
      processGovernanceDesc: 'Define, enforce, and audit operational processes with granular control.',
      executiveReporting: 'Operational Analytics',
      executiveReportingDesc: 'Real-time dashboards and analytics for management decision-making.'
    },
    // Modules
    modules: {
      title: 'Industry Modules',
      description: 'Specialized extensions for specific operational environments.',
      warehouse: 'Warehouse Module',
      warehouseDesc: 'Inventory management, bonded goods control, release automation.',
      customs: 'Customs Module',
      customsDesc: 'Declaration control, compliance orchestration, clearance transparency.',
      logistics: 'Logistics Module',
      logisticsDesc: 'Shipment coordination, fleet tracking, cost management.',
      trading: 'Trading Module',
      tradingDesc: 'Partner oversight, pricing management, transaction audit.',
      compliance: 'Compliance Module',
      complianceDesc: 'Regulatory reporting, audit automation, risk monitoring.',
      analytics: 'Analytics Module',
      analyticsDesc: 'Management dashboards, KPI tracking, performance analysis.'
    },
    // Problems
    problems: {
      label: 'Challenge',
      title: 'Operational problems we solve',
      description: 'VLAGEN transforms fragmented operations into a structured, controlled environment.',
      problem1: 'Fragmented ERP, CRM, warehouse, and financial systems',
      problem2: 'Lack of real-time visibility across teams',
      problem3: 'Regulatory and compliance risks',
      problem4: 'Inventory leakage and capital inefficiency',
      problem5: 'Weak operational decision governance'
    },
    // Security
    security: {
      label: 'Security & Trust',
      title: 'Enterprise-grade operational security',
      subtitle: 'Your data stays in your infrastructure.',
      description: 'VLAGEN operates as a control layer within your ecosystem — not as a data broker. Operational control without compromising data sovereignty.',
      highlight: 'Operational control without compromising data sovereignty.',
      notDoTitle: 'Data Principles',
      guaranteeTitle: 'We guarantee',
      feature1: 'No data resale',
      feature2: 'No external exploitation',
      feature3: 'No hidden third-party access',
      feature4: 'Role-based permissions',
      feature5: 'Complete audit logging',
      feature6: 'Infrastructure-level encryption'
    },
    // Architecture
    architecture: {
      label: 'System Architecture',
      title: 'Central management layer',
      description: 'VLAGEN integrates above your ERP, CRM, WMS, financial and trading systems — consolidating operational signals into a single command surface.',
      note: 'We don\'t replace your systems. We align them.',
      diagramTitle: 'Operational management architecture',
      layer1: 'Command Surface',
      layer2: 'VLAGEN Control Layer',
      layer3: 'ERP / CRM / WMS / Finance / Trading Systems',
      dataFlow: 'Data flow',
      controlLayer: 'Control layer'
    },
    // Industries
    industries: {
      label: 'Industry Focus',
      title: 'Built for operational environments where control matters',
      description: 'VLAGEN provides structural governance in environments defined by complexity, capital risk, and regulation.',
      warehouse: 'Warehouse & Asset Operations',
      warehouseDesc: 'Inventory management, bonded/non-bonded goods control, release discipline.',
      customs: 'Customs & Trade Management',
      customsDesc: 'Declaration transparency, clearance control, compliance monitoring.',
      distribution: 'Distribution Networks',
      distributionDesc: 'Routing discipline, margin control, multi-node oversight.',
      logistics: 'Logistics & Fleet',
      logisticsDesc: 'Shipment coordination, asset tracking, cost management.',
      importExport: 'Import/Export Operations',
      importExportDesc: 'Trade document management, cross-border transparency.',
      b2b: 'B2B Trading & Partner Systems',
      b2bDesc: 'Partner oversight, pricing discipline, transaction audit.'
    },
    // Stats
    stats: {
      implementations: 'Implementations',
      countries: 'Countries',
      retention: 'Client retention',
      support: 'Support'
    },
    // Clients
    clients: {
      label: 'TRUSTED BY',
      title: 'Companies that chose VLAGEN',
      vterminal: 'Reduced processing time by 40%',
      tdnebo: 'Unified 5 systems into one panel',
      xport: 'Full control over logistics'
    },
    
    // CTA
    cta: {
      title: 'Establish structural control.',
      description: 'Schedule a strategic deployment session with our engineering leadership.',
      primary: 'Get Control',
      secondary: 'Explore VLAGEN OS'
    },
    // Testimonials
    testimonials: {
      label: 'Customer Success',
      title: 'Trusted by operations leaders',
      quote1: 'VLAGEN gave us visibility we never had before. Now we can see all our warehouse operations in real-time.',
      role1: 'Operations Director',
      company1: 'Logistics & Warehousing',
      quote2: 'The customs compliance module reduced our clearance time by 40%. ROI was evident in the first quarter.',
      role2: 'Trade Compliance Manager',
      company2: 'Import/Export',
      quote3: 'Finally, a system that works with our existing ERP, not instead of it. Integration was seamless.',
      role3: 'CIO',
      company3: 'Distribution'
    },
    // FAQ
    faq: {
      label: 'Frequently Asked Questions',
      title: 'Questions about VLAGEN',
      q1: 'What is operational infrastructure?',
      a1: 'Operational infrastructure is a control layer that sits above your existing business systems (ERP, CRM, WMS, etc.) to unify data, enforce governance, and provide executive visibility across all operations.',
      q2: 'Does VLAGEN replace our existing systems?',
      a2: 'No. VLAGEN integrates above your existing systems without replacement or disruption. We connect to your ERP, CRM, WMS, financial and trading systems to consolidate operational signals into a single management surface.',
      q3: 'What industries does VLAGEN serve?',
      a3: 'VLAGEN serves highly complex operational environments including warehouse and asset operations, customs and trade management, distribution networks, logistics and fleet, import/export operations, and B2B trading platforms.',
      q4: 'Is my data secure with VLAGEN?',
      a4: 'Your data stays in your infrastructure. VLAGEN operates as a control layer within your ecosystem — not as a data broker.',
      q5: 'How long does VLAGEN deployment take?',
      a5: 'Deployment follows our 5-phase framework. Timelines vary based on complexity, typically 4-12 weeks for initial deployment.'
    },
    // OS Page
    os: {
      label: 'LIVE DEMO',
      title: 'VLAGEN OS',
      subtitle: 'Real-time operational dashboard',
      description: 'Real-time visibility into your operational ecosystem. This demo shows how VLAGEN consolidates signals from warehouse, customs, logistics, and trading systems.',
      requestDemo: 'Request Full Demo',
      lastUpdate: 'Last update:',
      secondsAgo: 'seconds ago',
      activeOrders: 'Active Orders',
      inTransit: 'In Transit',
      pendingClearance: 'Pending Clearance',
      completedToday: 'Completed Today',
      warehouseStatus: 'Warehouse Status',
      operational: 'Operational',
      totalUnits: 'Total units in stock',
      bondedWarehouse: 'Bonded warehouse',
      customsProcessing: 'Customs Processing',
      processing: 'Processing',
      declarationsToday: 'Declarations today',
      approved: 'Approved',
      pending: 'Pending',
      logisticsOverview: 'Logistics Overview',
      onTimeDelivery: 'On-time delivery',
      fleetUtilization: 'Fleet utilization'
    },
    // Blog Page
    blog: {
      label: 'BLOG',
      title: 'Insights & Articles',
      subtitle: 'Expert content on operational efficiency and business management',
      ctaTitle: 'Want to learn more?',
      ctaDescription: 'Schedule a free consultation with our experts',
      ctaButton: 'Contact Us',
      allArticles: 'All Articles',
      readyToOptimize: 'Ready to optimize operations?',
      scheduleConsultation: 'Schedule a free consultation with our experts',
      getConsultation: 'Get Consultation',
      readAlso: 'Read Also'
    },
    // Contact Page
    contact: {
      label: 'CONTACT',
      title: 'Contact Us',
      subtitle: 'Schedule a strategic consultation',
      description: 'Connect with our engineering leadership to discuss how VLAGEN can establish operational control over your business systems.',
      formTitle: 'Consultation Request',
      fullName: 'Full Name',
      workEmail: 'Work Email',
      company: 'Company Name',
      phone: 'Phone Number',
      industry: 'Industry',
      selectIndustry: 'Select industry',
      message: 'How can we help?',
      messagePlaceholder: 'Which operational processes need control? What systems do you use?',
      submit: 'Send Request',
      contactInfo: 'Contact Information',
      address: 'Dubai, UAE',
      workingHours: 'Sun - Thu: 9:00 - 18:00 (GST)',
      phoneLabel: 'Phone',
      emailLabel: 'Email',
      officeLabel: 'Office',
      hoursLabel: 'Working Hours',
      responseTitle: 'What happens next?',
      responseSteps: [
        'We review your request',
        'Contact you for details',
        'Propose collaboration format'
      ],
      successTitle: 'Thank you!',
      successSubtitle: 'Your request has been received.',
      successMessage: 'Our team will contact you shortly to discuss your project.',
      backHome: 'Back to Home',
      sending: 'Sending...'
    },
    // Methodology Page
    methodology: {
      label: 'ARCHITECTURE',
      title: 'VLAGEN Implementation Framework',
      subtitle: 'A structured 5-phase approach ensuring successful deployment without disrupting existing operations.',
      whyTitle: 'Why our approach works',
      whyDesc: 'Unlike "one-size-fits-all" solutions, our methodology starts with understanding your unique operational environment.',
      phase1: 'Diagnosis',
      phase1Sub: 'Understanding your operations',
      phase1Time: '1-2 weeks',
      phase1Desc: 'We conduct a comprehensive audit of your existing systems, workflows, and pain points. This phase lays the foundation for everything that follows.',
      phase1Items: ['System landscape mapping', 'Process documentation', 'Pain point identification', 'Integration requirements'],
      phase2: 'Design',
      phase2Sub: 'Architecting your solution',
      phase2Time: '2-3 weeks',
      phase2Desc: 'Based on diagnosis findings, we design a custom control layer architecture that addresses your specific challenges.',
      phase2Items: ['Solution architecture blueprint', 'Integration specifications', 'User workflow design', 'Security and compliance plan'],
      phase3: 'Integration',
      phase3Sub: 'Connecting your systems',
      phase3Time: '3-4 weeks',
      phase3Desc: 'We deploy the VLAGEN control layer over your existing systems. This phase focuses on data unification and establishing governance structures.',
      phase3Items: ['System integrations', 'Data pipelines', 'Control dashboards', 'Process automation'],
      phase4: 'Validation',
      phase4Sub: 'Quality assurance',
      phase4Time: '1-2 weeks',
      phase4Desc: 'Thorough testing of all integrations, processes, and user scenarios. We verify everything works exactly as designed.',
      phase4Items: ['Integration testing', 'User acceptance testing', 'Performance verification', 'Security audit'],
      phase5: 'Launch & Support',
      phase5Sub: 'Going live together',
      phase5Time: 'Ongoing',
      phase5Desc: 'We guide your team through launch and provide ongoing support. Our relationship doesn\'t end at deployment — we\'re partners in your success.',
      phase5Items: ['Launch facilitation', 'Team training', 'Monitoring setup', '24/7 support access'],
      phasesLabel: 'IMPLEMENTATION',
      phasesTitle: 'Implementation Phases',
      timelineTitle: 'Typical Timeline',
      timelineDesc: 'Most deployments complete in 8-12 weeks, depending on complexity.',
      totalTime: 'Total: 8-12 weeks',
      timelineStart: 'Start',
      timelineLaunch: 'Launch',
      ctaTitle: 'Ready to start?',
      ctaDesc: 'Schedule a diagnostic call to discuss your operational challenges.',
      ctaButton: 'Schedule Diagnosis'
    },
    // Industries Page
    industriesPage: {
      label: 'SOLUTIONS',
      title: 'Operational control for your industry',
      subtitle: 'VLAGEN provides specialized solutions for complex operational environments where structure, visibility, and control are critical.',
      warehouse: {
        title: 'Warehouse Operations',
        desc: 'Complete control over inventory, bonded and non-bonded goods, release process automation.',
        features: ['Real-time inventory management', 'Bonded zone control', 'Release automation', 'Batch and expiry tracking']
      },
      customs: {
        title: 'Customs Management',
        desc: 'Declaration transparency, compliance monitoring, clearance process control.',
        features: ['Declaration management', 'Compliance monitoring', 'Document workflow automation', 'Customs authority integration']
      },
      logistics: {
        title: 'Logistics & Transport',
        desc: 'Shipment coordination, fleet tracking, route optimization and cost management.',
        features: ['Real-time tracking', 'Route optimization', 'Fleet management', 'Delivery cost control']
      },
      distribution: {
        title: 'Distribution',
        desc: 'Multi-node oversight, routing discipline, margin control.',
        features: ['Warehouse network management', 'Pricing control', 'Sales analytics', 'Partner management']
      },
      trading: {
        title: 'Trading Operations',
        desc: 'Partner oversight, pricing management, transaction audit.',
        features: ['Contract management', 'Pricing analytics', 'Transaction audit', 'Partner reporting']
      },
      importExport: {
        title: 'Import/Export',
        desc: 'Trade document management, cross-border operation visibility.',
        features: ['Document management', 'Shipment tracking', 'Currency control', 'Compliance requirements']
      }
    },
    // Partners Page
    partnersPage: {
      label: 'PARTNERS',
      title: 'VLAGEN Partner Ecosystem',
      subtitle: 'We collaborate with leading technology and consulting companies.',
      intro: 'Join our partner network to expand business capabilities and deliver comprehensive solutions to clients.',
      
      whyTitle: 'Why Partner with VLAGEN',
      whyItems: [
        'Access to a growing operational infrastructure market',
        'Joint projects with enterprise clients',
        'Technical support and training',
        'Marketing and sales support'
      ],
      
      typesTitle: 'Partnership Types',
      integrationTitle: 'Integration Partners',
      integrationDesc: 'Build connectors and integrations with enterprise systems.',
      integrationItems: ['API integrations', 'Data connectors', 'Joint solutions'],
      
      consultingTitle: 'Consulting Partners',
      consultingDesc: 'Help clients optimize operations with VLAGEN.',
      consultingItems: ['Operations audit', 'VLAGEN implementation', 'Team training'],
      
      technologyTitle: 'Technology Partners',
      technologyDesc: 'Provide infrastructure and complementary solutions.',
      technologyItems: ['Cloud infrastructure', 'Cybersecurity', 'AI/ML solutions'],
      
      processTitle: 'Partnership Process',
      processSteps: [
        { num: '01', title: 'Application', desc: 'Fill out the form and tell us about your company' },
        { num: '02', title: 'Evaluation', desc: 'We assess synergy and collaboration potential' },
        { num: '03', title: 'Agreement', desc: 'Define terms and partnership model' },
        { num: '04', title: 'Onboarding', desc: 'Technical training and resource access' }
      ],
      
      ctaTitle: 'Ready to Partner?',
      ctaDesc: 'Join the VLAGEN ecosystem and grow your business with us.',
      ctaButton: 'Apply for Partnership'
    },
    // Company Page
    companyPage: {
      label: 'COMPANY',
      title: 'About VLAGEN',
      subtitle: 'We build next-generation operational infrastructure for complex organizations.',
      
      missionTitle: 'Mission',
      missionDesc: 'To provide organizations with tools for structural control over their operations — not by replacing existing systems, but by aligning them into a unified control layer.',
      
      visionTitle: 'Vision',
      visionDesc: 'A world where operational complexity doesn\'t hinder business growth, but becomes a manageable asset through a unified layer of control and transparency.',
      
      principlesTitle: 'Principles',
      principles: [
        { title: 'Transparency', desc: 'Complete operational visibility at all levels' },
        { title: 'Control', desc: 'Structural management without micromanagement' },
        { title: 'Integration', desc: 'We work on top, not replace' },
        { title: 'Security', desc: 'Your data stays in your infrastructure' }
      ],
      
      focusTitle: 'Focus',
      focusDesc: 'We work with companies where operational control is critical:',
      focusItems: [
        'Warehouse and inventory management',
        'Import and customs administration',
        'Distribution and trading operations',
        'Logistics and flow coordination',
        'B2B ecosystems and partner networks',
        'Financial control'
      ],
      
      approachTitle: 'Approach',
      approachDesc: 'VLAGEN is not a SaaS product with fixed functionality. It\'s an architecture that adapts to your operational model.',
      approachItems: [
        { title: 'Diagnostics', desc: 'We understand your operational reality' },
        { title: 'Architecture', desc: 'We design a control layer for your processes' },
        { title: 'Integration', desc: 'We connect to existing systems' },
        { title: 'Scaling', desc: 'We grow with your business' }
      ],
      
      locationTitle: 'Presence',
      locationDesc: 'Headquartered in Dubai, UAE. Working with clients in MENA, CIS, and globally.',
      
      ctaTitle: 'Ready to talk?',
      ctaDesc: 'Let\'s discuss how VLAGEN can help your organization.',
      ctaButton: 'Contact Us'
    }
  },
  ar: {
    // Header
    nav: {
      os: 'VLAGEN OS',
      industries: 'القطاعات',
      cases: 'دراسات الحالة',
      methodology: 'المنهجية',
      partners: 'الشركاء',
      company: 'الشركة',
      contact: 'اتصل بنا',
      cta: 'احصل على السيطرة',
      backHome: 'الصفحة الرئيسية'
    },
    // Footer
    footer: {
      brand: 'البنية التحتية التشغيلية لعمليات الأعمال المعقدة.',
      product: 'المنتج',
      company: 'الشركة',
      contact: 'اتصل بنا',
      methodology: 'الهندسة المعمارية',
      industries: 'الحلول',
      cases: 'دراسات الحالة',
      about: 'عن الشركة',
      partners: 'الشركاء',
      blog: 'المدونة',
      address: 'دبي، الإمارات',
      rights: 'جميع الحقوق محفوظة.',
      privacy: 'سياسة الخصوصية',
      cookies: 'إشعار ملفات تعريف الارتباط',
      legal: 'قانوني',
      contactTitle: 'اتصل بنا'
    },
    // Legal
    legal: {
      privacyTitle: 'سياسة الخصوصية',
      privacyLastUpdated: 'آخر تحديث',
      consentCheckbox: 'أوافق على معالجة بياناتي الشخصية',
      consentLink: 'وفقاً لـ',
      privacyPolicy: 'سياسة الخصوصية',
      cookieNotice: 'يستخدم هذا الموقع ملفات تعريف الارتباط لتحسين تجربة المستخدم وضمان عمل الموقع بشكل صحيح. باستخدامك للموقع فإنك توافق على استخدام ملفات تعريف الارتباط.',
      cookieAccept: 'موافق',
      sections: {
        intro: {
          title: 'مقدمة',
          content: 'تصف سياسة الخصوصية هذه كيف تقوم VLAGEN GROUP ("الشركة"، "نحن") بجمع واستخدام وحماية البيانات الشخصية التي تقدمها عند استخدام موقعنا vlagengroup.com.'
        },
        dataCollected: {
          title: 'ما البيانات التي نجمعها',
          content: 'عند ملء نموذج الاتصال على موقعنا، نقوم بجمع البيانات الشخصية التالية:',
          items: [
            'الاسم الكامل',
            'عنوان البريد الإلكتروني',
            'رقم الهاتف',
            'اسم الشركة',
            'مجال العمل',
            'نص الرسالة'
          ]
        },
        purpose: {
          title: 'الغرض من معالجة البيانات',
          content: 'نستخدم بياناتك الشخصية حصرياً للأغراض التالية:',
          items: [
            'الرد على استفساراتك وطلباتك',
            'التواصل معك بشأن التعاون',
            'تقديم معلومات حول خدماتنا',
            'تحسين جودة الخدمة'
          ]
        },
        storage: {
          title: 'تخزين وحماية البيانات',
          content: 'نتخذ التدابير التقنية والتنظيمية اللازمة لحماية بياناتك الشخصية من الوصول غير المصرح به أو التعديل أو الكشف أو التدمير. يتم تخزين البيانات على خوادم آمنة ذات وصول محدود.'
        },
        sharing: {
          title: 'مشاركة البيانات مع أطراف ثالثة',
          content: 'لا نشارك بياناتك الشخصية مع أطراف ثالثة دون موافقتك، إلا كما يقتضيه القانون.'
        },
        rights: {
          title: 'حقوقك',
          content: 'لديك الحق في:',
          items: [
            'طلب معلومات حول بياناتك الشخصية التي نعالجها',
            'طلب تصحيح البيانات غير الدقيقة',
            'طلب حذف بياناتك الشخصية',
            'سحب الموافقة على معالجة البيانات'
          ]
        },
        contact: {
          title: 'اتصل بنا',
          content: 'لجميع الأسئلة المتعلقة بمعالجة البيانات الشخصية، يمكنك الاتصال بنا على:'
        }
      }
    },
    // Hero
    hero: {
      tagline: 'طبقة التحكم الرقمية',
      titleLine1: 'تحكم في عملياتك',
      titleLine2: '',
      titleAccent: 'فوق الأنظمة الحالية.',
      subtitle: 'منصة تشغيلية موحدة تجمع البيانات والعمليات والأنظمة في واجهة واحدة.',
      description: 'دون إعادة بناء عملك.',
      ctaPrimary: 'احصل على السيطرة',
      ctaSecondary: 'استكشف VLAGEN OS'
    },
    // Foundation
    foundation: {
      label: 'الأساس',
      title: 'الطبقة الأساسية',
      description: 'أساس كل تنفيذ VLAGEN. توحيد البيانات وإدارة العمليات والتقارير في سطح أوامر واحد.',
      dataUnification: 'توحيد البيانات',
      dataUnificationDesc: 'توحيد البيانات من جميع الأنظمة في مصدر واحد للمعلومات.',
      processGovernance: 'إدارة العمليات',
      processGovernanceDesc: 'تحديد وتنفيذ ومراجعة العمليات التشغيلية بتحكم دقيق.',
      executiveReporting: 'التحليلات التشغيلية',
      executiveReportingDesc: 'لوحات معلومات وتحليلات في الوقت الفعلي لاتخاذ القرارات الإدارية.'
    },
    // Keep other Arabic translations similar...
    modules: {
      title: 'وحدات القطاعات',
      description: 'امتدادات متخصصة لبيئات تشغيلية محددة.',
      warehouse: 'وحدة المستودع',
      warehouseDesc: 'إدارة المخزون، مراقبة البضائع المرتبطة، أتمتة الإفراج.',
      customs: 'وحدة الجمارك',
      customsDesc: 'مراقبة الإقرارات، تنسيق الامتثال، شفافية التخليص.',
      logistics: 'وحدة اللوجستيات',
      logisticsDesc: 'تنسيق الشحنات، تتبع الأسطول، إدارة التكاليف.',
      trading: 'وحدة التجارة',
      tradingDesc: 'مراقبة الشركاء، إدارة التسعير، تدقيق المعاملات.',
      compliance: 'وحدة الامتثال',
      complianceDesc: 'التقارير التنظيمية، أتمتة التدقيق، مراقبة المخاطر.',
      analytics: 'وحدة التحليلات',
      analyticsDesc: 'لوحات الإدارة، تتبع مؤشرات الأداء، تحليل الأداء.'
    },
    problems: {
      label: 'التحدي',
      title: 'المشاكل التشغيلية التي نحلها',
      description: 'يحول VLAGEN العمليات المجزأة إلى بيئة منظمة ومتحكم بها.',
      problem1: 'أنظمة ERP وCRM والمستودعات والمالية المجزأة',
      problem2: 'عدم وجود رؤية في الوقت الفعلي بين الفرق',
      problem3: 'المخاطر التنظيمية ومخاطر الامتثال',
      problem4: 'تسرب المخزون وعدم كفاءة رأس المال',
      problem5: 'ضعف حوكمة القرارات التشغيلية'
    },
    security: {
      label: 'الأمان والثقة',
      title: 'أمان تشغيلي بمستوى المؤسسات',
      subtitle: 'بياناتك تبقى في بنيتك التحتية.',
      description: 'يعمل VLAGEN كطبقة تحكم داخل نظامك البيئي - وليس كوسيط بيانات.',
      highlight: 'تحكم تشغيلي دون المساس بسيادة البيانات.',
      notDoTitle: 'مبادئ البيانات',
      guaranteeTitle: 'نضمن',
      feature1: 'لا إعادة بيع للبيانات',
      feature2: 'لا استغلال خارجي',
      feature3: 'لا وصول مخفي لأطراف ثالثة',
      feature4: 'أذونات قائمة على الأدوار',
      feature5: 'تسجيل تدقيق كامل',
      feature6: 'تشفير على مستوى البنية التحتية'
    },
    architecture: {
      label: 'هندسة النظام',
      title: 'طبقة الإدارة المركزية',
      description: 'يتكامل VLAGEN فوق أنظمة ERP وCRM وWMS والأنظمة المالية والتجارية - موحداً الإشارات التشغيلية في سطح أوامر واحد.',
      note: 'نحن لا نستبدل أنظمتك. نحن ننسقها.',
      diagramTitle: 'هندسة الإدارة التشغيلية',
      layer1: 'سطح الأوامر',
      layer2: 'طبقة تحكم VLAGEN',
      layer3: 'ERP / CRM / WMS / المالية / أنظمة التجارة',
      dataFlow: 'تدفق البيانات',
      controlLayer: 'طبقة التحكم'
    },
    industries: {
      label: 'تركيز القطاعات',
      title: 'مصمم لبيئات التشغيل حيث السيطرة مهمة',
      description: 'يوفر VLAGEN حوكمة هيكلية في بيئات تتحدد بالتعقيد ومخاطر رأس المال والتنظيم.',
      warehouse: 'عمليات المستودعات والأصول',
      warehouseDesc: 'إدارة المخزون، مراقبة البضائع المرتبطة وغير المرتبطة، انضباط الإفراج.',
      customs: 'إدارة الجمارك والتجارة',
      customsDesc: 'شفافية الإقرارات، مراقبة التخليص، مراقبة الامتثال.',
      distribution: 'شبكات التوزيع',
      distributionDesc: 'انضباط التوجيه، مراقبة الهامش، إشراف متعدد العقد.',
      logistics: 'اللوجستيات والأسطول',
      logisticsDesc: 'تنسيق الشحنات، تتبع الأصول، إدارة التكاليف.',
      importExport: 'عمليات الاستيراد/التصدير',
      importExportDesc: 'إدارة وثائق التجارة، شفافية عبر الحدود.',
      b2b: 'تجارة B2B وأنظمة الشركاء',
      b2bDesc: 'مراقبة الشركاء، انضباط التسعير، تدقيق المعاملات.'
    },
    // Stats
    stats: {
      implementations: 'عمليات التنفيذ',
      countries: 'دول',
      retention: 'الاحتفاظ بالعملاء',
      support: 'الدعم'
    },
    // Clients
    clients: {
      label: 'يثقون بنا',
      title: 'الشركات التي اختارت VLAGEN',
      vterminal: 'خفضنا وقت المعالجة بنسبة 40%',
      tdnebo: 'دمجنا 5 أنظمة في لوحة واحدة',
      xport: 'تحكم كامل في الخدمات اللوجستية'
    },
    
    cta: {
      title: 'أسس السيطرة الهيكلية.',
      description: 'حدد جلسة نشر استراتيجية مع قيادتنا الهندسية.',
      primary: 'احصل على السيطرة',
      secondary: 'استكشف VLAGEN OS'
    },
    testimonials: {
      label: 'نجاح العملاء',
      title: 'موثوق به من قبل قادة العمليات',
      quote1: 'أعطانا VLAGEN رؤية لم نحصل عليها من قبل. الآن يمكننا رؤية جميع عمليات المستودع في الوقت الفعلي.',
      role1: 'مدير العمليات',
      company1: 'اللوجستيات والتخزين',
      quote2: 'قللت وحدة الامتثال الجمركي وقت التخليص بنسبة 40%. كان العائد على الاستثمار واضحاً في الربع الأول.',
      role2: 'مدير الامتثال التجاري',
      company2: 'الاستيراد/التصدير',
      quote3: 'أخيراً، نظام يعمل مع ERP الحالي لدينا، وليس بدلاً منه. كان التكامل سلساً.',
      role3: 'مدير تقنية المعلومات',
      company3: 'التوزيع'
    },
    faq: {
      label: 'الأسئلة الشائعة',
      title: 'أسئلة حول VLAGEN',
      q1: 'ما هي البنية التحتية التشغيلية؟',
      a1: 'البنية التحتية التشغيلية هي طبقة تحكم تقع فوق أنظمة عملك الحالية (ERP، CRM، WMS، إلخ) لتوحيد البيانات وتنفيذ الحوكمة وتوفير الرؤية التنفيذية عبر جميع العمليات.',
      q2: 'هل يستبدل VLAGEN أنظمتنا الحالية؟',
      a2: 'لا. يتكامل VLAGEN فوق أنظمتك الحالية دون استبدال أو تعطيل. نتصل بأنظمة ERP وCRM وWMS والأنظمة المالية والتجارية لدمج الإشارات التشغيلية في سطح إدارة واحد.',
      q3: 'ما هي القطاعات التي يخدمها VLAGEN؟',
      a3: 'يخدم VLAGEN بيئات التشغيل عالية التعقيد بما في ذلك عمليات المستودعات والأصول، وإدارة الجمارك والتجارة، وشبكات التوزيع، واللوجستيات والأسطول، وعمليات الاستيراد/التصدير، ومنصات تجارة B2B.',
      q4: 'هل بياناتي آمنة مع VLAGEN؟',
      a4: 'تبقى بياناتك في بنيتك التحتية. يعمل VLAGEN كطبقة تحكم داخل نظامك البيئي - وليس كوسيط بيانات.',
      q5: 'كم يستغرق نشر VLAGEN؟',
      a5: 'يتبع النشر إطار العمل المكون من 5 مراحل. تختلف الجداول الزمنية بناءً على التعقيد، عادةً 4-12 أسبوعاً للنشر الأولي.'
    },
    os: {
      label: 'عرض مباشر',
      title: 'VLAGEN OS',
      subtitle: 'لوحة تحكم تشغيلية في الوقت الفعلي',
      description: 'رؤية في الوقت الفعلي لنظامك التشغيلي. يوضح هذا العرض كيف يدمج VLAGEN الإشارات من أنظمة المستودعات والجمارك واللوجستيات والتجارة.',
      requestDemo: 'طلب عرض كامل',
      lastUpdate: 'آخر تحديث:',
      secondsAgo: 'ثوانٍ مضت',
      activeOrders: 'الطلبات النشطة',
      inTransit: 'في الطريق',
      pendingClearance: 'في انتظار التخليص',
      completedToday: 'مكتمل اليوم',
      warehouseStatus: 'حالة المستودع',
      operational: 'يعمل',
      totalUnits: 'إجمالي الوحدات في المخزون',
      bondedWarehouse: 'مستودع مرتبط',
      customsProcessing: 'معالجة الجمارك',
      processing: 'جاري المعالجة',
      declarationsToday: 'إقرارات اليوم',
      approved: 'موافق عليه',
      pending: 'قيد المراجعة',
      logisticsOverview: 'نظرة عامة على اللوجستيات',
      onTimeDelivery: 'التسليم في الوقت المحدد',
      fleetUtilization: 'استخدام الأسطول'
    },
    // Blog Page
    blog: {
      label: 'المدونة',
      title: 'رؤى ومقالات',
      subtitle: 'مواد خبراء حول الكفاءة التشغيلية وإدارة الأعمال',
      ctaTitle: 'هل تريد معرفة المزيد؟',
      ctaDescription: 'حدد موعداً لاستشارة مجانية مع خبرائنا',
      ctaButton: 'تواصل معنا',
      allArticles: 'جميع المقالات',
      readyToOptimize: 'هل أنت مستعد لتحسين العمليات؟',
      scheduleConsultation: 'حدد موعداً لاستشارة مجانية مع خبرائنا',
      getConsultation: 'احصل على استشارة',
      readAlso: 'اقرأ أيضاً'
    },
    contact: {
      label: 'اتصل بنا',
      title: 'اتصل بنا',
      subtitle: 'حدد استشارة استراتيجية',
      description: 'تواصل مع قيادتنا الهندسية لمناقشة كيف يمكن لـ VLAGEN إنشاء تحكم تشغيلي على أنظمة عملك.',
      formTitle: 'طلب استشارة',
      fullName: 'الاسم الكامل',
      workEmail: 'البريد الإلكتروني للعمل',
      company: 'اسم الشركة',
      phone: 'رقم الهاتف',
      industry: 'القطاع',
      selectIndustry: 'اختر القطاع',
      message: 'كيف يمكننا المساعدة؟',
      messagePlaceholder: 'ما هي العمليات التشغيلية التي تحتاج إلى تحكم؟ ما هي الأنظمة التي تستخدمها؟',
      submit: 'إرسال الطلب',
      contactInfo: 'معلومات الاتصال',
      address: 'دبي، الإمارات',
      workingHours: 'الأحد - الخميس: 9:00 - 18:00 (GST)',
      phoneLabel: 'الهاتف',
      emailLabel: 'البريد الإلكتروني',
      officeLabel: 'المكتب',
      hoursLabel: 'ساعات العمل',
      responseTitle: 'ماذا يحدث بعد ذلك؟',
      responseSteps: [
        'نراجع طلبك',
        'نتواصل معك للحصول على التفاصيل',
        'نقترح صيغة التعاون'
      ],
      successTitle: 'شكراً لك!',
      successSubtitle: 'تم استلام طلبك.',
      successMessage: 'سيتواصل فريقنا معك قريباً لمناقشة مشروعك.',
      backHome: 'العودة إلى الرئيسية',
      sending: 'جاري الإرسال...'
    },
    methodology: {
      label: 'الهندسة المعمارية',
      title: 'إطار تنفيذ VLAGEN',
      subtitle: 'نهج منظم من 5 مراحل يضمن النشر الناجح دون تعطيل العمليات الحالية.',
      whyTitle: 'لماذا نهجنا يعمل',
      whyDesc: 'على عكس الحلول "الجاهزة"، تبدأ منهجيتنا بفهم بيئتك التشغيلية الفريدة.',
      phase1: 'التشخيص',
      phase1Sub: 'فهم عملياتك',
      phase1Time: '1-2 أسابيع',
      phase1Desc: 'نجري تدقيقاً شاملاً لأنظمتك الحالية وسير العمل ونقاط الألم. هذه المرحلة تضع الأساس لكل ما يلي.',
      phase1Items: ['خريطة المشهد النظامي', 'توثيق العمليات', 'تحديد نقاط الألم', 'متطلبات التكامل'],
      phase2: 'التصميم',
      phase2Sub: 'تصميم حلك',
      phase2Time: '2-3 أسابيع',
      phase2Desc: 'بناءً على نتائج التشخيص، نصمم هندسة طبقة تحكم مخصصة تعالج تحدياتك المحددة.',
      phase2Items: ['مخطط هندسة الحل', 'مواصفات التكامل', 'تصميم سير العمل', 'خطة الأمان والامتثال'],
      phase3: 'التكامل',
      phase3Sub: 'ربط أنظمتك',
      phase3Time: '3-4 أسابيع',
      phase3Desc: 'ننشر طبقة تحكم VLAGEN فوق أنظمتك الحالية. تركز هذه المرحلة على توحيد البيانات وإنشاء هياكل الحوكمة.',
      phase3Items: ['تكاملات النظام', 'خطوط البيانات', 'لوحات التحكم', 'أتمتة العمليات'],
      phase4: 'التحقق',
      phase4Sub: 'ضمان الجودة',
      phase4Time: '1-2 أسابيع',
      phase4Desc: 'اختبار شامل لجميع التكاملات والعمليات وسيناريوهات المستخدم. نتحقق من أن كل شيء يعمل تماماً كما صُمم.',
      phase4Items: ['اختبار التكامل', 'اختبار قبول المستخدم', 'التحقق من الأداء', 'تدقيق الأمان'],
      phase5: 'الإطلاق والدعم',
      phase5Sub: 'الانطلاق معاً',
      phase5Time: 'مستمر',
      phase5Desc: 'نوجه فريقك خلال الإطلاق ونوفر دعماً مستمراً. علاقتنا لا تنتهي عند النشر - نحن شركاء في نجاحك.',
      phase5Items: ['تسهيل الإطلاق', 'تدريب الفريق', 'إعداد المراقبة', 'دعم 24/7'],
      phasesLabel: 'التنفيذ',
      phasesTitle: 'مراحل التنفيذ',
      timelineTitle: 'الجدول الزمني النموذجي',
      timelineDesc: 'تكتمل معظم عمليات النشر في 8-12 أسبوعاً، حسب التعقيد.',
      totalTime: 'الإجمالي: 8-12 أسابيع',
      timelineStart: 'البداية',
      timelineLaunch: 'الإطلاق',
      ctaTitle: 'مستعد للبدء؟',
      ctaDesc: 'حدد مكالمة تشخيصية لمناقشة تحدياتك التشغيلية.',
      ctaButton: 'جدولة التشخيص'
    },
    industriesPage: {
      label: 'الحلول',
      title: 'تحكم تشغيلي لقطاعك',
      subtitle: 'يوفر VLAGEN حلولاً متخصصة لبيئات التشغيل المعقدة حيث الهيكل والرؤية والتحكم أمور حاسمة.',
      warehouse: {
        title: 'عمليات المستودعات',
        desc: 'تحكم كامل في المخزون، البضائع المرتبطة وغير المرتبطة، أتمتة عمليات الإفراج.',
        features: ['إدارة المخزون في الوقت الفعلي', 'مراقبة المناطق المرتبطة', 'أتمتة الإفراج', 'تتبع الدفعات والانتهاء']
      },
      customs: {
        title: 'إدارة الجمارك',
        desc: 'شفافية الإقرارات، مراقبة الامتثال، التحكم في عملية التخليص.',
        features: ['إدارة الإقرارات', 'مراقبة الامتثال', 'أتمتة سير المستندات', 'التكامل مع السلطات الجمركية']
      },
      logistics: {
        title: 'اللوجستيات والنقل',
        desc: 'تنسيق الشحنات، تتبع الأسطول، تحسين المسارات وإدارة التكاليف.',
        features: ['التتبع في الوقت الفعلي', 'تحسين المسارات', 'إدارة الأسطول', 'التحكم في تكاليف التوصيل']
      },
      distribution: {
        title: 'التوزيع',
        desc: 'إشراف متعدد العقد، انضباط التوجيه، مراقبة الهامش.',
        features: ['إدارة شبكة المستودعات', 'التحكم في التسعير', 'تحليلات المبيعات', 'إدارة الشركاء']
      },
      trading: {
        title: 'العمليات التجارية',
        desc: 'مراقبة الشركاء، إدارة التسعير، تدقيق المعاملات.',
        features: ['إدارة العقود', 'تحليلات التسعير', 'تدقيق المعاملات', 'تقارير الشركاء']
      },
      importExport: {
        title: 'الاستيراد/التصدير',
        desc: 'إدارة مستندات التجارة، رؤية العمليات عبر الحدود.',
        features: ['إدارة المستندات', 'تتبع الشحنات', 'مراقبة العملة', 'متطلبات الامتثال']
      }
    },
    partnersPage: {
      label: 'الشركاء',
      title: 'نظام شركاء VLAGEN',
      subtitle: 'نتعاون مع شركات التكنولوجيا والاستشارات الرائدة.',
      intro: 'انضم إلى شبكة شركائنا لتوسيع قدرات عملك وتقديم حلول شاملة للعملاء.',
      
      whyTitle: 'لماذا الشراكة مع VLAGEN',
      whyItems: [
        'الوصول إلى سوق البنية التحتية التشغيلية المتنامي',
        'مشاريع مشتركة مع عملاء المؤسسات',
        'الدعم الفني والتدريب',
        'دعم التسويق والمبيعات'
      ],
      
      typesTitle: 'أنواع الشراكة',
      integrationTitle: 'شركاء التكامل',
      integrationDesc: 'بناء الموصلات والتكاملات مع أنظمة المؤسسات.',
      integrationItems: ['تكاملات API', 'موصلات البيانات', 'حلول مشتركة'],
      
      consultingTitle: 'شركاء الاستشارات',
      consultingDesc: 'مساعدة العملاء على تحسين العمليات مع VLAGEN.',
      consultingItems: ['تدقيق العمليات', 'تنفيذ VLAGEN', 'تدريب الفريق'],
      
      technologyTitle: 'شركاء التكنولوجيا',
      technologyDesc: 'توفير البنية التحتية والحلول التكميلية.',
      technologyItems: ['البنية التحتية السحابية', 'الأمن السيبراني', 'حلول AI/ML'],
      
      processTitle: 'عملية الشراكة',
      processSteps: [
        { num: '01', title: 'التقديم', desc: 'املأ النموذج وأخبرنا عن شركتك' },
        { num: '02', title: 'التقييم', desc: 'نقيم التآزر وإمكانات التعاون' },
        { num: '03', title: 'الاتفاق', desc: 'تحديد الشروط ونموذج الشراكة' },
        { num: '04', title: 'الإعداد', desc: 'التدريب التقني والوصول إلى الموارد' }
      ],
      
      ctaTitle: 'مستعد للشراكة؟',
      ctaDesc: 'انضم إلى نظام VLAGEN ونمِّ عملك معنا.',
      ctaButton: 'تقدم للشراكة'
    },
    companyPage: {
      label: 'الشركة',
      title: 'عن VLAGEN',
      subtitle: 'نبني بنية تحتية تشغيلية من الجيل التالي للمؤسسات المعقدة.',
      
      missionTitle: 'المهمة',
      missionDesc: 'توفير أدوات للمؤسسات للتحكم الهيكلي في عملياتها — ليس باستبدال الأنظمة الحالية، بل بمواءمتها في طبقة تحكم موحدة.',
      
      visionTitle: 'الرؤية',
      visionDesc: 'عالم حيث لا يعيق التعقيد التشغيلي نمو الأعمال، بل يصبح أصلاً قابلاً للإدارة من خلال طبقة موحدة من التحكم والشفافية.',
      
      principlesTitle: 'المبادئ',
      principles: [
        { title: 'الشفافية', desc: 'رؤية تشغيلية كاملة على جميع المستويات' },
        { title: 'التحكم', desc: 'إدارة هيكلية بدون إدارة تفصيلية' },
        { title: 'التكامل', desc: 'نعمل فوق الأنظمة، لا نستبدلها' },
        { title: 'الأمان', desc: 'بياناتك تبقى في بنيتك التحتية' }
      ],
      
      focusTitle: 'التركيز',
      focusDesc: 'نعمل مع الشركات حيث التحكم التشغيلي أمر بالغ الأهمية:',
      focusItems: [
        'إدارة المستودعات والمخزون',
        'إدارة الاستيراد والجمارك',
        'عمليات التوزيع والتجارة',
        'الخدمات اللوجستية وتنسيق التدفقات',
        'أنظمة B2B وشبكات الشركاء',
        'الرقابة المالية'
      ],
      
      approachTitle: 'النهج',
      approachDesc: 'VLAGEN ليس منتج SaaS بوظائف ثابتة. إنه بنية تتكيف مع نموذجك التشغيلي.',
      approachItems: [
        { title: 'التشخيص', desc: 'نفهم واقعك التشغيلي' },
        { title: 'الهندسة', desc: 'نصمم طبقة تحكم لعملياتك' },
        { title: 'التكامل', desc: 'نتصل بالأنظمة الحالية' },
        { title: 'التوسع', desc: 'ننمو مع عملك' }
      ],
      
      locationTitle: 'التواجد',
      locationDesc: 'المقر الرئيسي في دبي، الإمارات. نعمل مع عملاء في منطقة الشرق الأوسط وشمال أفريقيا ورابطة الدول المستقلة وعالمياً.',
      
      ctaTitle: 'مستعد للحديث؟',
      ctaDesc: 'دعنا نناقش كيف يمكن لـ VLAGEN مساعدة مؤسستك.',
      ctaButton: 'تواصل معنا'
    }
  }
};
